"use client";
import { FC, useEffect, useState } from "react";
import FirstBlock from "./components/FirstBlock";
import About from "./components/About";

import Prize from "./components/Prize";
import Faq from "./components/FAQ";
import App from "./components/App";
import { getDataFromStrapi } from "@/strapi/api";

type Props = {
	strapiData?: any;
};

const HomeScreen: FC<Props> = ({ strapiData: initialStrapiData = {} }) => {
	const [strapiData, setStrapiData] = useState(initialStrapiData);

	useEffect(() => {
		let isActive = true;
		const load = async () => {
			const [faqs, powerSharkIsData, prizeData, tooltipsData] =
				await Promise.all([
					getDataFromStrapi("/api/faqs-main-page?populate=*"),
					getDataFromStrapi("/api/power-shark?populate=*"),
					getDataFromStrapi("/api/prize-blocks?populate=*"),
					getDataFromStrapi("/api/phone-tooltips?populate=*"),
				]);
			if (!isActive) {
				return;
			}
			setStrapiData({
				faqs,
				powerSharkIsData,
				prizeData,
				tooltipsData,
			});
		};
		load();
		return () => {
			isActive = false;
		};
	}, []);

	return (
		<>
			<div id='Main'>
				<FirstBlock />
			</div>

			{/* <About /> */}

			<div id='App'>
				<App strapiData={strapiData} />
			</div>
			<Prize strapiData={strapiData} />
			<div id='FAQ'>
				<Faq strapiData={strapiData} />
			</div>
		</>
	);
};

export default HomeScreen;
